import React, { ReactElement, useState } from 'react'
import { Flex, Text } from 'theme-ui'
import { Accordion } from 'ui'
import { FAQItem } from './index'

const FaqItemAccordion = ({ item }: { item: FAQItem }): ReactElement => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Accordion
      id={item.question}
      ariaLabelButtonName={item.question}
      tabIndex={0}
      svgStyle={{
        height: '2.8rem',
        width: '2.8rem',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: isOpen ? 'cyan30' : 'cyan10',
        borderRadius: '10rem',
      }}
      containerStyle={{
        width: '100%',
        height: '100%',
        backgroundColor: isOpen ? 'eerieBlack' : 'eerieBlack50',
        justifyContent: 'center',
        border: '1px solid',
        borderColor: isOpen ? 'cyan900' : 'blueYonder20',
        borderRadius: '1.2rem',
        '& > div:first-of-type': {
          height: '100%',
        },
      }}
      buttonStyle={{
        px: ['1.6rem', '2.4rem'],
        pb: isOpen ? 0 : '2.4rem',
        pt: isOpen ? ['3.2rem', '4rem'] : '2.4rem',
        height: '100%',
        ':hover': {
          '& svg path': {
            fill: 'cyan600',
          },
          '& span': {
            opacity: 1,
          },
        },
      }}
      title={
        <Text
          as="h3"
          variant="size19Weigh600Line138"
          sx={{
            maxWidth: '64rem',
            color: isOpen ? 'aliceBlue' : 'cadetGrey',
            mr: '1.2rem',
          }}
        >
          {item.question}
        </Text>
      }
      isOpenControlled={isOpen}
      setIsOpenControlled={() => setIsOpen(!isOpen)}
    >
      <Flex
        tabIndex={0}
        sx={{
          width: '100%',
          color: 'pewterBlue',
          textAlign: 'left',
          px: ['1.6rem', '2.4rem'],
          pt: '1.6rem',
          pb: ['3.2rem', '4rem'],
        }}
      >
        <Text variant="size16Weight400Line140Letter08">{item.answer}</Text>
      </Flex>
    </Accordion>
  )
}

export default FaqItemAccordion
